import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UnderWrittingSummary from './UnderWrittingSummary';
import { doHardCheck, setAcceptedHardCheck } from './underWrittingSummaryActions';

function UnderWrittingSummaryContainer(props) {
    return (
        <UnderWrittingSummary
            setStep={props.setStep}
            setStepCompleted={props.setStepCompleted}
            setAcceptedHardCheck={props.setAcceptedHardCheck}
            acceptedHardCheck={props.acceptedHardCheck}
            doHardCheck={props.doHardCheck}
            hardCheckCompleted={props.hardCheckCompleted}
            isPending={props.isPending}
        />
    );
}

const mapStateToProps = state => ({
    acceptedHardCheck: state.underWrittingSummaryReducer.acceptedHardCheck,
    hardCheckCompleted: state.underWrittingSummaryReducer.hardCheckCompleted,
    isPending: state.underWrittingSummaryReducer.isPending,
});

const mapDispatchToProps = dispatch => ({
    setAcceptedHardCheck: (event) => {
        dispatch(setAcceptedHardCheck(event));
    },
    doHardCheck: () => {
        dispatch(doHardCheck());
    },
});

UnderWrittingSummaryContainer.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setAcceptedHardCheck: PropTypes.func.isRequired,
    acceptedHardCheck: PropTypes.bool.isRequired,
    doHardCheck: PropTypes.func.isRequired,
    hardCheckCompleted: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UnderWrittingSummaryContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/UnderwrittingSummary/UnderWrittingSummaryContainer.js